module.exports = __webpack_public_path__ + "static/media/harvard.34dd0a2c.jpg";